export default __webpack_public_path__ + "static/media/coin-toolbox.346df886.svg";